import { useForm } from '@mantine/form'
import React from 'react'
import { modals } from '@mantine/modals'
import {
    Button,
    Flex,
    LoadingOverlay,
    PasswordInput,
    TextInput,
} from '@mantine/core'
import { IRequestCreateUser } from '@apiinterface/IUser'
import User from '@api/User'
import InputUserRole from '@components/inputs/quiz/InputUserRole'

const FormCreateUser = ({ refresh }: { refresh: () => {} }) => {
    const form = useForm<IRequestCreateUser>({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            confirmpassword: '',
            username: '',
            role: 1,
        },
    })
    const { onSubmit, isLoading } = User.useCreateUser({
        form: form,
        aftersuccess: () => {
            modals.closeAll()
            refresh()
        },
    })
    return (
        <form onSubmit={onSubmit}>
            <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />
            <Flex direction='column' gap='md'>
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('first_name')}
                    label='ชื่อจริง'
                    placeholder='ชื่อจริง '
                    data-autofocus
                />
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('last_name')}
                    label='นามสกุล'
                    placeholder='นามสกุล '
                    data-autofocus
                />
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('username')}
                    label='ชื่อผู้ใช้งาน'
                    placeholder='ชื่อผู้ใช้งาน '
                    data-autofocus
                />
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('email')}
                    label='อีเมล:'
                    placeholder='อีเมล '
                />
                <InputUserRole
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('role')}
                    label='สิทธิการใช้งาน:'
                    placeholder='สิทธิการใช้งาน '
                />
                <PasswordInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('password')}
                    label='รหัสผ่าน:'
                    placeholder='รหัสผ่าน '
                    data-autofocus
                />
                <PasswordInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('confirmpassword')}
                    label='ยืนยันรหัสผ่าน:'
                    placeholder='ยืนยันรหัสผ่าน '
                    data-autofocus
                />
                <Button
                    fullWidth
                    type='submit'
                    radius='10px'
                    mt='md'
                    color='#e6007e'
                >
                    ยืนยัน
                </Button>
            </Flex>
        </form>
    )
}

export default FormCreateUser
